module.exports = __webpack_public_path__ + "static/media/find-friends.a3a15a5a.png";